import React from 'react';

import InputSettingsField from './InputSettingsField';
import CheckboxSettingsField from './CheckboxSettingsField';
import ButtonSettings from './ButtonSettings';
import { StyledFieldWrapper, DividerLine } from './SettingsCommonElements';

import FieldSettingsMetadataTypes from '../../../constants/FieldSettingsMetadataTypes';

const MetadataSettings = ({ metadata, metadataOptions, onChange }) => {

  if (!metadataOptions || metadataOptions.length < 1) return null;

  return metadataOptions.map((config, i) => {

    let settingNode = null;

    /**
     * Meta Value
     *
     * Step 1: First we try to grab the value from the field.metadata
     * Step 2: If no field.metadata exists then check the settings config for a default display value
     */
    const value = metadata && metadata.hasOwnProperty && metadata.hasOwnProperty(config.key) ? metadata[config.key]
      : (config.value || (config.type === FieldSettingsMetadataTypes.checkbox ? false : ''));

    if (
      config.type === FieldSettingsMetadataTypes.text
      || config.type === FieldSettingsMetadataTypes.number
      || config.type === FieldSettingsMetadataTypes.textarea
    ) {
      settingNode = (
        <InputSettingsField
          value={value}
          label={config.label}
          description={config.description}
          addon={config.addon}
          type={config.type}
          disabled={config.disabled}
          rows={config.rows}
          onChange={(fieldId, value) => (value ? onChange({ [config.key]: value }) : '')}
        />
      );
    } else if (config.type === FieldSettingsMetadataTypes.checkbox) {
      settingNode = (
        <CheckboxSettingsField
          id={config.key}
          label={config.label}
          description={config.description}
          selected={value}
          disabled={config.disabled}
          onChange={(selected) => {
            onChange({ [config.key]: selected });
          }}
        />
      );
    } else if (config.type === FieldSettingsMetadataTypes.button) {
      settingNode = (
        <ButtonSettings
          color={config.color}
          label={config.label}
          description={config.description}
          disabled={config.disabled}
          value={value}
          onChange={() => {
            onChange({ [config.key]: value ? '' : value });
          }}
        />
      );
    } else if (config.type === FieldSettingsMetadataTypes.divider) {
      return (
        <DividerLine key={`${config.type}-${i}`} />
      );
    }

    return (
      <StyledFieldWrapper key={i}>
        {settingNode}
      </StyledFieldWrapper>
    );

  });

};

export default MetadataSettings;
